module.exports = __webpack_public_path__ + "static/media/gabriella.99dcabbe.png";